module AppKitchen {

    export module Controls {

        export module Menus {

            // ReSharper disable once InconsistentNaming
            export interface SearchMenuAttributes extends AppKitchen.ModelBaseAttributes {

            }

            export class SearchMenuModel extends AppKitchen.ModelBase<SearchMenuAttributes> {
                
            }

            // ReSharper disable once InconsistentNaming
            export interface SearchMenuViewOptions extends AppKitchen.ViewBaseOptions {
                menuItems: MenuItem[]
            }

            export class SearchMenuView extends AppKitchen.ViewBase<SearchMenuModel> {
                options: SearchMenuViewOptions;

                containers: {
                    searchBox: HTMLElement,
                    navigationMenu: HTMLElement,
                }

                constructor(model: SearchMenuModel, target: HTMLElement, options?: SearchMenuViewOptions) {
                    super(model, target, options);
                    this.options = options;

                    AppKitchen.UIHelper.renderTemplateTo(this.el,
                        AppKitchen.Templates.SearchMenu,
                        { actionIcon: "icon-info" });

                    this.containers = {
                        searchBox: this.$el.find(".a-searchbox-container")[0],
                        navigationMenu: this.$el.find(".a-navigation-menu-container")[0]
                    }

                    this.render();
                }

                render() {
                    var searchBoxModel = new AppKitchen.Controls.SearchBoxModel({ query: "" });
                    // ReSharper disable once WrongExpressionStatement
                    new AppKitchen.Controls.SearchBoxView(searchBoxModel, this.containers.searchBox, {
                        placeholder: "Suchen"
                    });

                    var facilitiesMenu = new AppKitchen.Controls.Menus.VerticalMenu(this.containers.navigationMenu, this.options.menuItems, {
                        customScroller: true,
                        routingParameter: "facility",
                        routingHistory: false,
                        sort: true,
                        autoSelect: false
                    });

                    searchBoxModel.onChange(query => {
                            facilitiesMenu.filter(query);
                    });
                }
            }

        }

    }
}
